module.exports = __webpack_public_path__ + "img/pic_170122.e6db9bed.jpg";